import { OpenEndCodedVariableDto, PaginatedQuery, SortDirections, SorterDescriptor } from "app/ApiClient";
import { oeCodingTableConfig } from "const/OECoding";
import { LoadingState } from "types";
export interface PaginatedDtoOfOECoding {
  pageData?: OECoding[] | undefined;
  totalCount?: number;
  pageNumber?: number;
  pageSize?: number;
}

export type OECoding = OpenEndCodedVariableDto
export interface OECodings extends PaginatedDtoOfOECoding {
  allData: OECoding[];
  pageData: OECoding[];
}

export interface PageContextOfOECodingFilter {
  page?: PaginatedQuery | undefined;
  sortList?: SorterDescriptor[] | undefined;
}

export const initialPageContext: PageContextOfOECodingFilter = {
  page: {
    pageNumber: oeCodingTableConfig.DefaultPageNumber,
    pageSize: oeCodingTableConfig.DefaultPageSize,
  },
  sortList: [{ directions: SortDirections.Desceding, field: "createdAt" }],
};

export interface OECodingMessage {
  id: string;
  status: LoadingState,
  message: string; 
}

 export interface OECodingFilter extends Omit<OECoding, "id" | "variableFullName">{
  id?: number, 
  variableFullName?: string
 }

export type OECodingState = {
  createOECodingVariableState: LoadingState;
  oeCodingVariables: OECodings;
  oeCodingLoadingState : LoadingState;
  alertMessages : Array<OECodingMessage>
  pageContext: PageContextOfOECodingFilter;
  filters?: { [key in keyof OECodingFilter]: string[]  };
};

export const initialOECodingState: OECodingState = {
  createOECodingVariableState: LoadingState.idle,
  oeCodingVariables: {
    allData: [],
    pageData: [],
  },
  oeCodingLoadingState : LoadingState.idle,
  alertMessages:[],
  pageContext: initialPageContext,
};
